<template>
  <ValidatePassword
    ref="passwordDialog"
    custom-endpoint
    autocomplete
    @submit="tryLogin"
    @hide="hide"
    @native-prefilled="checkboxSavePassword = true"
  >
    <span>Your session is about to expire. Please re-enter your password to remain logged in or alternatively switch accounts.</span>

    <template v-if="showSavePassword" #actions>
      <q-checkbox
        v-model="checkboxSavePassword"
        label="Save Login Details"
        class="q-mx-xs q-mb-sm"
      />
    </template>

    <template #buttons>
      <q-btn
        flat
        label="Switch Accounts"
        color="blue-grey"
        no-caps
        @click="hide"
      />
    </template>
  </ValidatePassword>
</template>

<script>
import ValidatePassword from 'components/partials/ValidatePassword.vue'
import auth from 'components/auth'

// This component is used for dynamic calls for reauthorizing the user's session
// Refer to https://quasar.dev/quasar-plugins/dialog#Invoking-custom-component
export default {
  components: {
    ValidatePassword
  },
  emits: [
    // REQUIRED
    'ok', 'hide'
  ],
  data () {
    return {
      retryCounter: 0,
      showSavePassword: false,
      checkboxSavePassword: false
    }
  },
  methods: {
    // following method is REQUIRED
    // (don't change its name --> "show")
    show () {
      this.$refs.passwordDialog.open()

      if (this.$nativeSecureStorage) {
        this.showSavePassword = true
      }
    },
    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide () {
      this.$refs.passwordDialog.close()
      this.$emit('hide')
    },
    tryLogin ({ loading, done, submit, onError }) {
      loading()
      const portal = this.$store.getters.getPortal
      let endpoint = null
      switch (portal) {
        case 'business': endpoint = 'business-login'; break
        case 'user': endpoint = 'client-connect-login'; break
      }
      auth.login(endpoint, submit(), (token) => {
        this.retryCounter = 0
        this.onOKClick(token)
        this.$refs.passwordDialog.close()

        // Attempt to save in SecureStorage if using Capacitor
        if (this.showSavePassword) {
          if (!this.checkboxSavePassword) {
            this.$nativeSecureStorage.remove({ key: 'login_details' })
          }
          else {
            this.$nativeSecureStorage.set({
              key: 'login_details',
              value: JSON.stringify({
                email: submit().email,
                password: submit().password
              })
            })
          }
        }
      }, (errors, message) => {
        if (this.retryCounter >= 2) {
          this.hide()
          return
        }
        this.retryCounter++
        onError(message, {
          password: ['Your password is incorrect']
        })
        done()
      })
    },
    onOKClick (token = null) {
      // on OK, it is REQUIRED to
      // emit "ok" event (with optional payload)
      // before hiding the QDialog
      this.$emit('ok', token)
    },
    onCancelClick () {
      // we just need to hide dialog
      this.hide()
    }
  }
}
</script>
